import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function Offer() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} id="comprar" className="w-full bg-gradient-to-b from-dark-navy to-darker-navy py-20 md:py-28 px-6" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.6
      }} className="bg-dark-navy p-10 md:p-14 rounded-2xl border-4 border-gold shadow-2xl" data-id="element-53">
          <div className="text-center mb-10" data-id="element-54">
            <h2 className="text-4xl md:text-5xl font-oswald text-gold mb-6 leading-tight" data-id="element-55">
              Protege el futuro social y emocional de tu hijo hoy mismo
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-56">
              Accede a la Guía de Supervivencia Social y Digital con todos los
              bonos incluidos por un pago único.
            </p>
          </div>

          <div className="bg-gradient-to-br from-gold/20 to-cyan/20 p-8 rounded-xl mb-10 border-2 border-gold/50" data-id="element-57">
            <div className="text-center" data-id="element-58">
              <p className="text-gray-400 text-lg mb-2" data-id="element-59">Inversión Total:</p>
              <div className="flex items-center justify-center gap-4 mb-4" data-id="element-60">
                <span className="text-6xl md:text-7xl font-oswald text-gold" data-id="element-61">
                  $8.27
                </span>
                <span className="text-2xl text-gray-400" data-id="element-62">USD</span>
              </div>
              <p className="text-cyan font-semibold" data-id="element-63">
                Pago único • Acceso instantáneo
              </p>
            </div>
          </div>

          <motion.a href="https://guiadownload.com/products/guia-de-supervivencia-social-y-digital" target="_blank" rel="noopener noreferrer" className="block w-full bg-gold text-dark-navy text-center px-8 py-6 rounded-xl font-oswald text-2xl md:text-3xl hover:bg-yellow-400 transition-colors shadow-lg mb-6" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-64">
            ¡QUIERO LA GUÍA AHORA!
          </motion.a>

          <div className="flex flex-col md:flex-row gap-4 justify-center items-center text-gray-400 text-sm" data-id="element-65">
            <div className="flex items-center gap-2" data-id="element-66">
              <LockIcon className="w-4 h-4" data-id="element-67" />
              <span data-id="element-68">Compra segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-69">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-70" />
              <span data-id="element-71">Acceso instantáneo en formato PDF</span>
            </div>
          </div>

          <p className="text-center text-gray-500 text-sm mt-6" data-id="element-72">
            Compatible con todos los dispositivos
          </p>
        </motion.div>
      </div>
    </section>;
}